/**
 * Phase 18.16-B Batch 1 — /moving + /verhuizing (CMS-driven).
 */
import React from "react";
import SEO from "../components/SEO";
import ServicePageCmsWrapper from "../components/ServicePageCmsWrapper";

const MOVING_FALLBACK = {
  page_banner: {
    eyebrow: "Verhuizing",
    title: "Verhuizen naar de",
    highlight: "Caribbean",
    subtitle: "Complete verzorging van uw emigratie of remigratie — van dozen en meubels tot containerverhuizing en documentatie.",
    badges: [
      { icon: "truck", label: "Door to door" },
      { icon: "package", label: "Container & groupage" },
      { icon: "shield", label: "Verzekerd verhuizen" },
    ],
    cta_primary_label: "Verhuisofferte aanvragen",
    cta_primary_url: "/contact?get-quote=1#quote-form",
    cta_secondary_label: "Bel voor advies",
    cta_secondary_url: "tel:+31488235999",
  },
  intro: {
    eyebrow: "Verhuisopties",
    title: "Compleet of zelf inpakken — u kiest",
    subtitle: "Van dozen + meubels tot complete containerverhuizingen, inclusief documentatie en advies over importvrijstellingen waar van toepassing.",
  },
  cta_band: {
    title: "Bereken uw verhuizing",
    description: "Persoonlijk verhuisadvies + indicatieve offerte binnen 1 werkdag.",
    cta_primary_label: "Verhuisofferte aanvragen",
    cta_primary_url: "/contact?get-quote=1#quote-form",
    cta_secondary_label: "Bel voor advies",
    cta_secondary_url: "tel:+31488235999",
  },
  cards: [],
};

export default function MovingPage() {
  return (
    <>
      <SEO
        title="Verhuizen naar de Caribbean | 5999Cargo"
        description="Complete verzorging van uw emigratie of remigratie van Nederland naar de Caribbean."
      />
      <ServicePageCmsWrapper
        slug="moving"
        fallback={MOVING_FALLBACK}
        testid="moving-page"
      />
    </>
  );
}
